// extracted by mini-css-extract-plugin
module.exports = {"track":"Toggle_track__2lMdY","on":"Toggle_on__3AJMh","thumb":"Toggle_thumb__2jklp","load":"Toggle_load__iSUql"};